export default "__VITE_ASSET__df3f61fd__"